import {PageWithLayout, requireUnauth} from "../Page";
import {Navigate} from "react-router-dom";
import {SetNewPassword} from "../../components/reset-password/SetNewPassword";
import {CentralContent} from "../../components/central-content/CentralContent";
import {VerifyEmail} from "../../components/verify-email/VerifyEmail";

export const EmailActionsPage = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const mode = searchParams.get("mode");
  const oobCode = searchParams.get("oobCode");
  if (mode !== "resetPassword" && mode !== "verifyEmail") {
    return <Navigate to="/error?error=invalid_email_action"/>
  }
  if (!oobCode) {
    return <Navigate to="/error?error=oob_code_missing"/>
  }

  const content = mode === "resetPassword" ? (
    <SetNewPassword oobCode={oobCode}/>
  ) : (
    <VerifyEmail oobCode={oobCode}/>
  );

  const pageContent = <PageWithLayout variant="secondary" showHeader={true} stickContentToTop={false}>
    <CentralContent>
        {content}
    </CentralContent>
  </PageWithLayout>

  if (mode === "verifyEmail") {
      return pageContent;
  }

  return requireUnauth(pageContent);
};
